import Pantry from './pantry'

export default Pantry
